var App = App || {};

App.PageMasthead = (function ($) {
    "use strict";

    var LgBp = 992,
        xsBp = 576,
        imgWidth = 330,
        imgHeight = 280;

    function init() {
        if ($(".page-masthead.category").length) {
            $(".page-masthead.category .category-masthead-subpages").ZagScrollAnimate({
                offset: 100,
                targets: [
                    { selector: ".subpage-card", type: "animate__fadeInUp", stagger: 0 }
                ]
            });
            $(".page-masthead .category-masthead-image-wrapper").ZagParallax({ divisor: 2 });
        }

        var detailImgWrap = $(".page-masthead .detail-masthead-image-wrapper");
        if (detailImgWrap.length) {
            adjustImageSize(detailImgWrap);
            detailImgWrap.ZagParallax({ divisor: 18 });

            $(window).on("resize scroll", function () {
                adjustImageSize(detailImgWrap);
            });
        }
    }

    function adjustImageSize(detailImgWrap) {
        if ($(window).width() < LgBp) {
            detailImgWrap.css("max-width", "100%");
        } else {
            detailImgWrap.css("max-width", (detailImgWrap.outerHeight() * imgWidth / imgHeight));
        }
        if ($(window).width() < xsBp) {
            detailImgWrap.addClass("xsMobile");
            detailImgWrap.css("max-height", (detailImgWrap.outerWidth() * imgHeight / imgWidth));
        }
        else {
            detailImgWrap.removeClass("xsMobile");
            detailImgWrap.css("max-height", "");
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PageMasthead.init();
});